import { render, staticRenderFns } from "./labelItem.vue?vue&type=template&id=a06d3970&scoped=true&"
import script from "./labelItem.vue?vue&type=script&lang=ts&"
export * from "./labelItem.vue?vue&type=script&lang=ts&"
import style0 from "./labelItem.vue?vue&type=style&index=0&id=a06d3970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d3970",
  null
  
)

export default component.exports